import * as z from 'zod';

export const ParticipantStatusSchema = z.enum(['PENDING', 'APPROVED', 'REJECTED', 'CANCELLED'])

export type ParticipantStatus = z.infer<typeof ParticipantStatusSchema>;